// Generated by CoffeeScript 2.7.0
var Proposer;

import FieldMixins from 'trunks/vue/admin/components/fields/mixins/field_mixin.js';

import BaseField from './field.js';

import SerialNumberFieldMixin from './mixin.js';

export default Proposer = Vue.extend({
  mixins: [FieldMixins, SerialNumberFieldMixin],
  components: {
    FieldView: BaseField
  },
  template: `<FieldView
  ref="fieldView"
  :editing='editing'
  :field="field"
>
  <Dropdown
    slot='optionbar'
    :optionGroups='ruleCurrentGroups'
    :initValue='ruleCurrentGroup'
    :optionGroupsFixed='true'
    class="custom-dropdown ml-3"
    style="width: 10rem"
    @change='optionChanged'
  >
    <template slot='value-template' slot-scope='{ option }'>
      <span>{{ option.label }}</span>
    </template>
    <template slot='option-template' slot-scope='{ option }'>
      <div class="justify-between">
        <span>{{ option.label }}</span>
        <span class="helper-text">{{ option.description }}</span>
      </div>
    </template>
  </Dropdown>
  <template slot='description'>
    <span>在编号中插入发起人的姓名</span>
  </template>
  <template slot='content'>
    <div>{{ _getDescriptionOfField() }}</div>
  </template>
</FieldView>`,
  data: function() {
    return {
      ruleCurrentGroup: null
    };
  },
  watch: {
    ruleCurrentGroups: function() {
      var _option, options;
      options = this.ruleCurrentGroups[0].options;
      _option = _.find(options, (option) => {
        return option.params.rule === this.field.settings.rule;
      });
      if (!_option) {
        _option = _.first(options);
      }
      this.field.settings = {...this.field.settings, ..._option.params};
      return this.ruleCurrentGroup = _option;
    }
  },
  methods: {
    optionChanged: function(option) {
      this.field.settings.rule = option.params.rule;
      return this.ruleCurrentGroup = option;
    },
    _getDescriptionOfField: function() {
      var ref;
      return `[${((ref = this.ruleCurrentGroup) != null ? ref.label : void 0) || ''}]`;
    }
  }
});
